import React from 'react'

import { shape, string } from 'prop-types'

const LINKS = {
  '{terms}': { key: 'terms', href: '/pages/terms-and-conditions' },
  '{privacy}': { key: 'privacy', href: '/pages/privacy-policy' },
}

const PLACEHOLDER_PATTERN = /(\{terms\}|\{privacy\})/

function LegalNote({ legal }) {
  return (
    <p className="datasets-legal-note">
      {legal.text.split(PLACEHOLDER_PATTERN).map((part, index) => {
        const link = LINKS[part]

        if (!link) return part

        return (
          <a
            key={index}
            className="datasets-legal-note__link"
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {legal[link.key]}
          </a>
        )
      })}
    </p>
  )
}

LegalNote.propTypes = {
  legal: shape({
    text: string.isRequired,
    terms: string.isRequired,
    privacy: string.isRequired,
  }).isRequired,
}

export default LegalNote
